import { ChainId } from '../constants'

export function getEtherscanLinkForTransaction(transactionHash: string, chainId: ChainId) {
  return getEtherscanLink(chainId, `tx/${transactionHash}`)
}

export function getEtherscanLinkForAddress(address: string, chainId: ChainId) {
  return getEtherscanLink(chainId, `address/${address}`)
}

function getEtherscanLink(chainId: ChainId, path: string) {
  switch (chainId) {
    case ChainId.Mainnet:
      return `https://etherscan.io/${path}`
    case ChainId.Kovan:
      return `https://kovan.etherscan.io/${path}`
    case ChainId.Ganache:
      return 'https://en.wikipedia.org/wiki/Special:Random'
  }
}
